module.exports = __webpack_public_path__ + "img/VP-Profi13_Overview-Front_2.721fa3a1.jpg";